import _toConsumableArray from "G:\\__main\\_work\\_projects\\Cinemex\\cinemex-2018-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "G:\\__main\\_work\\_projects\\Cinemex\\cinemex-2018-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "G:\\__main\\_work\\_projects\\Cinemex\\cinemex-2018-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
var e = function () {
    if ("undefined" == typeof self) return !1;
    if ("top" in self && self !== top) try {
      top.window.document._ = 0;
    } catch (e) {
      return !1;
    }
    return "showOpenFilePicker" in self;
  }(),
  t = e ? Promise.resolve().then(function () {
    return l;
  }) : Promise.resolve().then(function () {
    return v;
  });
function n() {
  return _n.apply(this, arguments);
}
function _n() {
  _n = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
    var _yield$t;
    var _args11 = arguments;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return t;
          case 2:
            return _context11.abrupt("return", (_yield$t = _context11.sent).default.apply(_yield$t, _args11));
          case 3:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _n.apply(this, arguments);
}
var r = e ? Promise.resolve().then(function () {
  return y;
}) : Promise.resolve().then(function () {
  return b;
});
function i() {
  return _i.apply(this, arguments);
}
function _i() {
  _i = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
    var _yield$r;
    var _args12 = arguments;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return r;
          case 2:
            return _context12.abrupt("return", (_yield$r = _context12.sent).default.apply(_yield$r, _args12));
          case 3:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _i.apply(this, arguments);
}
var a = e ? Promise.resolve().then(function () {
  return m;
}) : Promise.resolve().then(function () {
  return k;
});
function o() {
  return _o.apply(this, arguments);
}
function _o() {
  _o = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
    var _yield$a;
    var _args13 = arguments;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.next = 2;
            return a;
          case 2:
            return _context13.abrupt("return", (_yield$a = _context13.sent).default.apply(_yield$a, _args13));
          case 3:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _o.apply(this, arguments);
}
var s = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
    var t;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return e.getFile();
          case 2:
            t = _context.sent;
            return _context.abrupt("return", (t.handle = e, t));
          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function s(_x) {
    return _ref.apply(this, arguments);
  };
}();
var c = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var e,
        t,
        n,
        r,
        _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              e = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : [{}];
              Array.isArray(e) || (e = [e]);
              t = [];
              e.forEach(function (e, n) {
                t[n] = {
                  description: e.description || "Files",
                  accept: {}
                }, e.mimeTypes ? e.mimeTypes.map(function (r) {
                  t[n].accept[r] = e.extensions || [];
                }) : t[n].accept["*/*"] = e.extensions || [];
              });
              _context2.next = 6;
              return window.showOpenFilePicker({
                id: e[0].id,
                startIn: e[0].startIn,
                types: t,
                multiple: e[0].multiple || !1,
                excludeAcceptAllOption: e[0].excludeAcceptAllOption || !1
              });
            case 6:
              n = _context2.sent;
              _context2.next = 9;
              return Promise.all(n.map(s));
            case 9:
              r = _context2.sent;
              return _context2.abrupt("return", e[0].multiple ? r : r[0]);
            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function c() {
      return _ref2.apply(this, arguments);
    };
  }(),
  l = {
    __proto__: null,
    default: c
  };
function u(e) {
  function t(e) {
    if (Object(e) !== e) return Promise.reject(new TypeError(e + " is not an object."));
    var t = e.done;
    return Promise.resolve(e.value).then(function (e) {
      return {
        value: e,
        done: t
      };
    });
  }
  return u = function u(e) {
    this.s = e, this.n = e.next;
  }, u.prototype = {
    s: null,
    n: null,
    next: function next() {
      return t(this.n.apply(this.s, arguments));
    },
    return: function _return(e) {
      var n = this.s.return;
      return void 0 === n ? Promise.resolve({
        value: e,
        done: !0
      }) : t(n.apply(this.s, arguments));
    },
    throw: function _throw(e) {
      var n = this.s.return;
      return void 0 === n ? Promise.reject(e) : t(n.apply(this.s, arguments));
    }
  }, new u(e);
}
var p = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e, t) {
    var n,
      r,
      i,
      a,
      o,
      s,
      c,
      _loop,
      l,
      d,
      _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            n = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : e.name;
            r = _args3.length > 3 ? _args3[3] : undefined;
            i = [], a = [];
            s = !1, c = !1;
            _context3.prev = 4;
            _loop = function _loop() {
              var o = l.value,
                s = "".concat(n, "/").concat(o.name);
              "file" === o.kind ? a.push(o.getFile().then(function (t) {
                return t.directoryHandle = e, t.handle = o, Object.defineProperty(t, "webkitRelativePath", {
                  configurable: !0,
                  enumerable: !0,
                  get: function get() {
                    return s;
                  }
                });
              })) : "directory" !== o.kind || !t || r && r(o) || i.push(p(o, t, s, r));
            };
            d = function (e) {
              var t,
                n,
                r,
                i = 2;
              for ("undefined" != typeof Symbol && (n = Symbol.asyncIterator, r = Symbol.iterator); i--;) {
                if (n && null != (t = e[n])) return t.call(e);
                if (r && null != (t = e[r])) return new u(t.call(e));
                n = "@@asyncIterator", r = "@@iterator";
              }
              throw new TypeError("Object is not async iterable");
            }(e.values());
          case 7:
            _context3.next = 9;
            return d.next();
          case 9:
            if (!(s = !(l = _context3.sent).done)) {
              _context3.next = 14;
              break;
            }
            _loop();
          case 11:
            s = !1;
            _context3.next = 7;
            break;
          case 14:
            _context3.next = 19;
            break;
          case 16:
            _context3.prev = 16;
            _context3.t0 = _context3["catch"](4);
            c = !0, o = _context3.t0;
          case 19:
            _context3.prev = 19;
            _context3.prev = 20;
            _context3.t1 = s && null != d.return;
            if (!_context3.t1) {
              _context3.next = 25;
              break;
            }
            _context3.next = 25;
            return d.return();
          case 25:
            _context3.prev = 25;
            if (!c) {
              _context3.next = 28;
              break;
            }
            throw o;
          case 28:
            return _context3.finish(25);
          case 29:
            return _context3.finish(19);
          case 30:
            _context3.t2 = [];
            _context3.t3 = _toConsumableArray;
            _context3.next = 34;
            return Promise.all(i);
          case 34:
            _context3.t4 = _context3.sent.flat();
            _context3.t5 = (0, _context3.t3)(_context3.t4);
            _context3.t6 = _toConsumableArray;
            _context3.next = 39;
            return Promise.all(a);
          case 39:
            _context3.t7 = _context3.sent;
            _context3.t8 = (0, _context3.t6)(_context3.t7);
            return _context3.abrupt("return", _context3.t2.concat.call(_context3.t2, _context3.t5, _context3.t8));
          case 42:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[4, 16, 19, 30], [20,, 25, 29]]);
  }));
  return function p(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();
var d = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var e,
        t,
        _args4 = arguments;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              e = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
              e.recursive = e.recursive || !1, e.mode = e.mode || "read";
              _context4.next = 4;
              return window.showDirectoryPicker({
                id: e.id,
                startIn: e.startIn,
                mode: e.mode
              });
            case 4:
              t = _context4.sent;
              _context4.next = 7;
              return t.values();
            case 7:
              _context4.next = 9;
              return _context4.sent.next();
            case 9:
              if (!_context4.sent.done) {
                _context4.next = 13;
                break;
              }
              _context4.t0 = [t];
              _context4.next = 14;
              break;
            case 13:
              _context4.t0 = p(t, e.recursive, void 0, e.skipDirectory);
            case 14:
              return _context4.abrupt("return", _context4.t0);
            case 15:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return function d() {
      return _ref4.apply(this, arguments);
    };
  }(),
  y = {
    __proto__: null,
    default: d
  },
  f = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e) {
      var t,
        n,
        r,
        i,
        a,
        o,
        s,
        c,
        _t,
        _args5 = arguments;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              t = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : [{}];
              n = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : null;
              r = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : !1;
              i = _args5.length > 4 && _args5[4] !== undefined ? _args5[4] : null;
              Array.isArray(t) || (t = [t]), t[0].fileName = t[0].fileName || "Untitled";
              a = [];
              o = null;
              if (!(e instanceof Blob && e.type ? o = e.type : e.headers && e.headers.get("content-type") && (o = e.headers.get("content-type")), t.forEach(function (e, t) {
                a[t] = {
                  description: e.description || "Files",
                  accept: {}
                }, e.mimeTypes ? (0 === t && o && e.mimeTypes.push(o), e.mimeTypes.map(function (n) {
                  a[t].accept[n] = e.extensions || [];
                })) : o ? a[t].accept[o] = e.extensions || [] : a[t].accept["*/*"] = e.extensions || [];
              }), n)) {
                _context5.next = 17;
                break;
              }
              _context5.prev = 8;
              _context5.next = 11;
              return n.getFile();
            case 11:
              _context5.next = 17;
              break;
            case 13:
              _context5.prev = 13;
              _context5.t0 = _context5["catch"](8);
              if (!(n = null, r)) {
                _context5.next = 17;
                break;
              }
              throw _context5.t0;
            case 17:
              _context5.t1 = n;
              if (_context5.t1) {
                _context5.next = 22;
                break;
              }
              _context5.next = 21;
              return window.showSaveFilePicker({
                suggestedName: t[0].fileName,
                id: t[0].id,
                startIn: t[0].startIn,
                types: a,
                excludeAcceptAllOption: t[0].excludeAcceptAllOption || !1
              });
            case 21:
              _context5.t1 = _context5.sent;
            case 22:
              s = _context5.t1;
              !n && i && i(s);
              _context5.next = 26;
              return s.createWritable();
            case 26:
              c = _context5.sent;
              if (!("stream" in e)) {
                _context5.next = 32;
                break;
              }
              _t = e.stream();
              _context5.next = 31;
              return _t.pipeTo(c);
            case 31:
              return _context5.abrupt("return", s);
            case 32:
              if (!("body" in e)) {
                _context5.next = 38;
                break;
              }
              _context5.next = 35;
              return e.body.pipeTo(c);
            case 35:
              _context5.t2 = s;
              _context5.next = 47;
              break;
            case 38:
              _context5.t3 = c;
              _context5.next = 41;
              return e;
            case 41:
              _context5.t4 = _context5.sent;
              _context5.next = 44;
              return _context5.t3.write.call(_context5.t3, _context5.t4);
            case 44:
              _context5.next = 46;
              return c.close();
            case 46:
              _context5.t2 = s;
            case 47:
              return _context5.abrupt("return", _context5.t2);
            case 48:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[8, 13]]);
    }));
    return function f(_x4) {
      return _ref5.apply(this, arguments);
    };
  }(),
  m = {
    __proto__: null,
    default: f
  },
  w = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var e,
        _args6 = arguments;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              e = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : [{}];
              return _context6.abrupt("return", (Array.isArray(e) || (e = [e]), new Promise(function (t, n) {
                var r = document.createElement("input");
                r.type = "file";
                var i = [].concat(_toConsumableArray(e.map(function (e) {
                  return e.mimeTypes || [];
                })), _toConsumableArray(e.map(function (e) {
                  return e.extensions || [];
                }))).join();
                r.multiple = e[0].multiple || !1, r.accept = i || "", r.style.display = "none", document.body.append(r);
                var a = function a(e) {
                    "function" == typeof o && o(), t(e);
                  },
                  o = e[0].legacySetup && e[0].legacySetup(a, function () {
                    return o(n);
                  }, r),
                  s = function s() {
                    window.removeEventListener("focus", s), r.remove();
                  };
                r.addEventListener("click", function () {
                  window.addEventListener("focus", s);
                }), r.addEventListener("change", function () {
                  window.removeEventListener("focus", s), r.remove(), a(r.multiple ? Array.from(r.files) : r.files[0]);
                }), "showPicker" in HTMLInputElement.prototype ? r.showPicker() : r.click();
              })));
            case 2:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    return function w() {
      return _ref6.apply(this, arguments);
    };
  }(),
  v = {
    __proto__: null,
    default: w
  },
  h = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var e,
        _args7 = arguments;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              e = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : [{}];
              return _context7.abrupt("return", (Array.isArray(e) || (e = [e]), e[0].recursive = e[0].recursive || !1, new Promise(function (t, n) {
                var r = document.createElement("input");
                r.type = "file", r.webkitdirectory = !0;
                var i = function i(e) {
                    "function" == typeof a && a(), t(e);
                  },
                  a = e[0].legacySetup && e[0].legacySetup(i, function () {
                    return a(n);
                  }, r);
                r.addEventListener("change", function () {
                  var t = Array.from(r.files);
                  e[0].recursive ? e[0].recursive && e[0].skipDirectory && (t = t.filter(function (t) {
                    return t.webkitRelativePath.split("/").every(function (t) {
                      return !e[0].skipDirectory({
                        name: t,
                        kind: "directory"
                      });
                    });
                  })) : t = t.filter(function (e) {
                    return 2 === e.webkitRelativePath.split("/").length;
                  }), i(t);
                }), "showPicker" in HTMLInputElement.prototype ? r.showPicker() : r.click();
              })));
            case 2:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
    return function h() {
      return _ref7.apply(this, arguments);
    };
  }(),
  b = {
    __proto__: null,
    default: h
  },
  P = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(e) {
      var t,
        n,
        r,
        i,
        a,
        _args10 = arguments;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              t = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : {};
              Array.isArray(t) && (t = t[0]);
              n = document.createElement("a");
              r = e;
              _context10.t0 = "body" in e;
              if (!_context10.t0) {
                _context10.next = 9;
                break;
              }
              _context10.next = 8;
              return function () {
                var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(e, t) {
                  var n, r, i, a;
                  return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          n = e.getReader();
                          r = new ReadableStream({
                            start: function start(e) {
                              return function () {
                                var _t2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
                                  return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                                    while (1) {
                                      switch (_context8.prev = _context8.next) {
                                        case 0:
                                          return _context8.abrupt("return", n.read().then(function (_ref10) {
                                            var n = _ref10.done,
                                              r = _ref10.value;
                                            if (!n) return e.enqueue(r), t();
                                            e.close();
                                          }));
                                        case 1:
                                        case "end":
                                          return _context8.stop();
                                      }
                                    }
                                  }, _callee8);
                                }));
                                function t() {
                                  return _t2.apply(this, arguments);
                                }
                                return t;
                              }()();
                            }
                          });
                          i = new Response(r);
                          _context9.next = 5;
                          return i.blob();
                        case 5:
                          a = _context9.sent;
                          return _context9.abrupt("return", (n.releaseLock(), new Blob([a], {
                            type: t
                          })));
                        case 7:
                        case "end":
                          return _context9.stop();
                      }
                    }
                  }, _callee9);
                }));
                return function (_x6, _x7) {
                  return _ref9.apply(this, arguments);
                };
              }()(e.body, e.headers.get("content-type"));
            case 8:
              r = _context10.sent;
            case 9:
              n.download = t.fileName || "Untitled";
              _context10.t1 = URL;
              _context10.next = 13;
              return r;
            case 13:
              _context10.t2 = _context10.sent;
              n.href = _context10.t1.createObjectURL.call(_context10.t1, _context10.t2);
              i = function i() {
                "function" == typeof a && a();
              }, a = t.legacySetup && t.legacySetup(i, function () {
                return a();
              }, n);
              return _context10.abrupt("return", (n.addEventListener("click", function () {
                setTimeout(function () {
                  return URL.revokeObjectURL(n.href);
                }, 3e4), i();
              }), n.click(), null));
            case 17:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));
    return function P(_x5) {
      return _ref8.apply(this, arguments);
    };
  }(),
  k = {
    __proto__: null,
    default: P
  };
export { i as directoryOpen, h as directoryOpenLegacy, d as directoryOpenModern, n as fileOpen, w as fileOpenLegacy, c as fileOpenModern, o as fileSave, P as fileSaveLegacy, f as fileSaveModern, e as supported };